import { CollapseLeft, CollapseRight } from "assets/icons/Common";
import { Col, IconButton } from "components/primitives";
import { FC, useEffect, useState } from "react";
import styled from "styled-components";
import { DashboardProps } from "types/GlobalData";

import { BackgroundsToolbar } from "./BackgroundsToolbar";
import { FontsToolbar } from "./FontsToolbar";
import { MainToolbar } from "./MainToolbar";
import { SettingsToolbar } from "./SettingsToolbar";
import { SoundsToolbar } from "./SoundsToolbar";

interface Props {
  widgetCounts: { [widgetType: string]: number };
  addWidget: (typeId: string, dashboardId: string) => void;
  data: DashboardProps;
  onSetData: (data: DashboardProps) => void;
  loading?: boolean;
}

export interface SegmentProps extends Props {
  setCurrentSegment: (id: string) => void;
}

const toolbarSegments: { [id: string]: FC<SegmentProps> } = {
  main: MainToolbar,
  settings: SettingsToolbar,
  backgrounds: BackgroundsToolbar,
  sounds: SoundsToolbar,
  fonts: FontsToolbar,
};

export const ToolbarContainer: FC<Props> = ({ ...props }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [currentSegment, setCurrentSegment] = useState("main");

  const [loading, setLoading] = useState(false);

  const Segment = toolbarSegments[currentSegment];

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 100);
    if (isOpen) {
      setCurrentSegment("main");
    }
  }, [isOpen, setCurrentSegment]);

  return (
    <SlideContainer aria-expanded={isOpen}>
      <CloseButton
        Icon={isOpen ? CollapseLeft : CollapseRight}
        onClick={() => setIsOpen(!isOpen)}
        withShadow={false}
      />
      <InnerContainer>
        <Segment {...props} loading={loading} setCurrentSegment={(id) => setCurrentSegment(id)} />
      </InnerContainer>
    </SlideContainer>
  );
};

const SlideContainer = styled.div`
  --toolbar-width: 14rem;
  position: fixed;
  height: 100dvh;
  width: var(--toolbar-width);
  z-index: 6000;
  left: calc(var(--toolbar-width) * -1 + 10px);
  container-type: size;
  container-name: settings-bar;
  background-color: white;
  box-shadow: 0 0 3px 0;

  transition: left 300ms ease;

  border-right: thin solid black;

  &[aria-expanded="true"] {
    left: 0;
  }
`;

const InnerContainer = styled(Col)`
  padding: 10px;
  width: 100%;
  height: 100%;
  align-items: center;
`;

const CloseButton = styled(IconButton)`
  position: absolute;
  top: 10px;
  right: 0;
  width: 30px;
  height: 30px;
  transform: translate(80%, 0);
`;
